var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vcwrapie"},[_vm._v("\n    此浏览器不支持摄像头调用，建议使用CHROME浏览器。\n")])}
var staticRenderFns = []

export { render, staticRenderFns }